import React, { memo, ReactNode } from 'react';

import Clickable from '@prisjakt/ui-clickable';

import { NotificationTypes } from './types';

import * as S from './styles';
import { IconClose } from '@prisjakt/ui/icon';

type Props = {
  className?: string;
  type: NotificationTypes;
  title?: string | ReactNode;
  message: string | ReactNode;
  time?: string;
  onClose?: () => void;
  link?: Link;
};

type Link = {
  text: string;
  url: string;
  icon?: React.ReactElement;
  isExternal?: boolean;
};

const Notification = ({
  className,
  type,
  title,
  message,
  time,
  onClose,
  link,
}: Props) => {
  const notification = (
    <S.Notification
      type={type}
      className={className}
      hasCloseButton={Boolean(onClose)}
    >
      <S.Message>
        {(title || time) && (
          <S.Header>
            {title && <S.Title>{title}</S.Title>}

            {time && (
              <>
                {title && <S.Divider />}
                <S.Date>{time}</S.Date>
              </>
            )}
          </S.Header>
        )}

        <p>{message}</p>
      </S.Message>

      {onClose && (
        <S.CloseButton
          variant="icon"
          icon={<IconClose />}
          size="small"
          color={type === NotificationTypes.ISSUE ? 'negative' : 'primary'}
          onClick={onClose}
        />
      )}
    </S.Notification>
  );

  return link?.url ? (
    <Clickable to={link.url} isExternal={link.isExternal}>
      {notification}
    </Clickable>
  ) : (
    notification
  );
};

export default memo(Notification);
